export const PAGES = {
  LANDING: "LANDING",
  FORM: "FORM",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const ACCOUNT_INFO_LOADED = "ACCOUNT_INFO_LOADED";
export const START_CLICKED = "START_CLICKED";
export const FORM_SUBMITTED = "FORM_SUBMITTED";
export const FORM_SUBMISSION_FAILED = "FORM_SUBMISSION_FAILED";
